import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getItemCentralStorageBranchesLocationSorted } from '../../selectors/item-retailer';
import { getRetailerDocument } from '../../selectors/retailer';

interface CentralStorageProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const CentralStorage = ({ onClick }: CentralStorageProps) => {
  const { t } = useTranslation('item');
  const retailer = useSelector(getRetailerDocument);
  const centralStorageBranches = useSelector(getItemCentralStorageBranchesLocationSorted);

  if (!retailer || !centralStorageBranches || !centralStorageBranches.length) return null;

  return (
    <div className="convert-card-body bg-accent">
      <div data-am-columnrow="always" className="font-size-small">
        <div className="column">
          <div className="font-medium">{t('Central storage', { ns: 'item' })}</div>
        </div>
        <div className="column minimal">
          <button
            type="button"
            onClick={onClick}
            title={t('Change dealer', { ns: 'item' })}
            data-am-link="font-inherit"
            className="l-block"
          >
            {t('Change dealer', { ns: 'item' })}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CentralStorage;
